module.exports = __webpack_public_path__ + "static/img/change-sometimes-01.ac18466.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/change-sometimes-01.jpg
// module id = 249
// module chunks = 1